module.exports = __webpack_public_path__ + "img/institute-francais.8b590dfc.png";